export const Triggers = () => {
  return <></>
}

export default Triggers
